import { FC } from 'react';
import { useDispatch } from 'react-redux';

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { actions } from '@state/global';
import { timeAgo } from '@utils/time-ago';
import { Box, Button, Step, Text } from '@versumstudios/ui';

export interface IInSessionNotification {
  notificationid: string;
  timestamp: number;
  viewed: boolean;
  type: string;
  success: boolean;
  hash: string;
}

export const InSessionNotification: FC<IInSessionNotification> = ({
  notificationid,
  timestamp,
  viewed,
  type,
  success,
  hash,
}) => {
  const dispatch = useDispatch();

  const markHasRead = () => {
    dispatch({
      type: actions.GLOBAL_USER_VIEWS_NOTIFICATION,
      payload: notificationid,
    });
  };

  return (
    <Button
      as="a"
      variant="basic"
      href={`https://tzstats.com/${hash}`}
      target="_blank"
      rel="noopener noreferrer"
      css={{ borderRadius: 0, border: 'none', width: '100%' }}
    >
      <DropdownMenu.Item asChild onClick={markHasRead}>
        <Box
          css={{
            width: '100%',
            padding: 12,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '$secondaryBackground',
            },
            '&:focus': { outline: 'none' },
          }}
        >
          <Box css={{ marginRight: '$space$4', width: 40, height: 40 }} vertical horizontal>
            <Step success={success} error={!success} />
          </Box>
          <Box
            css={{
              flexGrow: 1,
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Text unset css={{ fontSize: 14, color: '$secondaryFill' }}>
                {success ? `Your ${type} was successful.` : `Your ${type} failed`}
              </Text>
            </Box>
            <Box>
              <Text unset css={{ color: '$secondaryFill', fontSize: 14 }}>
                {timeAgo.format(timestamp)}
              </Text>
            </Box>
          </Box>
          {!viewed && (
            <Box vertical horizontal>
              <Box
                css={{
                  width: 8,
                  height: 8,
                  backgroundColor: '$primaryHighlight',
                  borderRadius: 9999,
                }}
              />
            </Box>
          )}
        </Box>
      </DropdownMenu.Item>
    </Button>
  );
};
